// pages/control/CreateUser.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useControlAuth } from '../ControlAuthContext';
import './CreateUser.css';

const CreateUser = () => {
  const [userid, setUserid] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [accesstype, setAccesstype] = useState(1);
  const [error, setError] = useState(null);
  const { user } = useControlAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (user.accesstype !== 0) {
      setError('Access denied');
      return;
    }
    const token = localStorage.getItem('controlToken');
    try {
      await axios.post('https://valleyapi-dr9y.onrender.com/api/control/users', { userid, name, email, password, accesstype }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      navigate('/control/user-control');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create user');
      console.error(err);
    }
  };

  return (
    <div className="create-user-page-container">
      <h2>Create New User</h2>
      <form onSubmit={handleSubmit}>
        <div className="create-user-form-group">
          <label>UserID:</label>
          <input type="text" value={userid} onChange={(e) => setUserid(e.target.value)} required />
        </div>
        <div className="create-user-form-group">
          <label>Name:</label>
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
        </div>
        <div className="create-user-form-group">
          <label>Email:</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div className="create-user-form-group">
          <label>Password:</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        <div className="create-user-form-group">
          <label>Access Type:</label>
          <select value={accesstype} onChange={(e) => setAccesstype(parseInt(e.target.value))}>
            <option value={0}>0 (Full Access)</option>
            <option value={1}>1 (Limited Access)</option>
          </select>
        </div>
        <button type="submit" className="create-user-submit-button">Create</button>
      </form>
      {error && <p className="create-user-error-message">{error}</p>}
    </div>
  );
};

export default CreateUser;